export default __webpack_public_path__ + "static/linkGeneartionBackground-c73dc770571058b9cf402fe81b177ee4.png";